import script from "./OrdersV2.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersV2.vue?vue&type=script&setup=true&lang=js"

import "./OrdersV2.vue?vue&type=style&index=0&id=63c12fd0&lang=css"

const __exports__ = script;

export default __exports__